import { placeholderLink } from './LinkDefaults';
import { LinkColumns, LinkLevel, NavType, ComponentType } from '../ui/shared/LinkTypes';
import { Target } from '../ui/shared/enums/Target';
import { Context } from '../ui/shared/enums/Context';
import { FontWeight } from '../ui/shared/enums/FontWeight';
import { UnderLineType } from '../ui/shared/enums/UnderLineType';
import { VisualStyle } from '../ui/shared/enums/VisualStyle';
/**
 * Default configuration for navigation items
 */
export const defaultMenuItemMolecule = {
    // Link Properties
    id: 0,
    text: '',
    link: '',
    target: Target.Self,
    // Style Properties
    fontWeight: FontWeight.Normal,
    hoverColor: '',
    isUnderLine: UnderLineType.None,
    linkColor: Context.None,
    visualStyle: VisualStyle.Default,
    componentType: ComponentType.Internal,
    // Navigation Properties
    columns: LinkColumns.One,
    isSubmenu: false,
    level: LinkLevel.Zero,
    order: 0,
    parentId: '',
    navType: NavType.Primary,
};
/**
 * Placeholder configuration for navigation items, for use in testing or development
 */
export const placeholderMenuItemMolecule = {
    ...placeholderLink, // Ensures all relevant BaseLink properties are included
    // children: [],
    columns: LinkColumns.Two,
    isSubmenu: true,
    level: LinkLevel.Zero,
    order: 1,
    parentId: '12',
    navType: NavType.Nested, // Using updated property name
    visualStyle: VisualStyle.Highlighted, // Assuming Highlighted is a valid value
};
//# sourceMappingURL=MenuItemDefaults.js.map